exports.connect = {
	url: "https://api.lesclarines.camp/"
}
